import { css } from "@emotion/react";
import { getCustomResponsiveStyles } from "@/utils";
import { Colors, Shadows, Typography } from "@zapier/design-system";

const minPlanCardContentWidth = 184;

type PlanOverViewRowsProps = {
  isTrialing?: boolean;
  isContactSalesCTA?: boolean;
};

const getPlanOverviewRows = ({
  isContactSalesCTA,
  isTrialing,
}: PlanOverViewRowsProps) => {
  const descriptionRowHeight = isTrialing
    ? "minmax(135px, max-content)"
    : "minmax(100px, max-content)";

  return isContactSalesCTA
    ? `40px ${descriptionRowHeight} 136px 73px minmax(30px, max-content);`
    : `40px ${descriptionRowHeight} 80px 100px minmax(30px, max-content);`;
};

export const styles = {
  contactSalesCTACopyWrapper: css`
    padding-top: 7px;
  `,

  recommendedLabel: css({
    alignItems: "center",
    backgroundColor: Colors.earth,
    color: Colors.white,
    display: "flex",
    height: "27px",
    justifyContent: "center",
    paddingBottom: "2px",
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    ...Typography.smallPrint1Semibold,
  }),

  highlightLabelContent: css({
    alignItems: "center",
    display: "flex",
    height: "27px",
    justifyContent: "center",
  }),

  highlightLabelIcon: css({
    display: "flex",
    marginLeft: "4px",
  }),

  recommendedPlanOverviewWrapper: getCustomResponsiveStyles({
    mobile: css({
      border: `2px solid ${Colors.earth}`,
      marginTop: 0,
      paddingTop: "calc(20px + 28px)",
    }),

    tablet: css({
      marginBottom: "-30px",
      top: "-30px",
    }),
  }),

  tableFeatureRoot: css`
    height: 100%;
  `,
  topFeaturesTitle: css`
    height: 40px;
    margin: 20px 0 10px 0;
  `,
  tableFeatureWrapper: css`
    padding: 20px 20px 8px;
  `,
  secondaryCtaWrapper: css`
    display: flex;
    align-items: flex-end;
    justify-content: center;
  `,
  planFeatures: getCustomResponsiveStyles({
    tablet: css`
      width: 100%;
      display: grid;
    `,
    mobile: css`
      display: inline-block;
      min-width: ${minPlanCardContentWidth}px;
      padding: 0 20px;
      width: 100%;
    `,
  }),

  planFeaturesWrapper: css`
    display: flex;
    justify-content: center;
  `,

  planOverview: ({ isContactSalesCTA, isTrialing }: PlanOverViewRowsProps) =>
    getCustomResponsiveStyles({
      mobile: css`
      display: grid;
      grid-template-rows: ${getPlanOverviewRows({
        isContactSalesCTA,
        isTrialing,
      })}
      height: 100%;
      margin: 0 auto;
    `,
    }),

  currentPlanCard: getCustomResponsiveStyles({
    mobile: css({
      background: Colors.acidWash,
      border: "none",
    }),
  }),

  planOverviewWrapper: (isTableFeatureOn: boolean) =>
    getCustomResponsiveStyles({
      mobile: css({
        ":hover": {
          boxShadow: Shadows.elevation6,
        },
        background: Colors.neutral100,
        borderRadius: 3,
        border: `1px solid ${Colors.neutral400}`,
        display: "block",
        padding: isTableFeatureOn ? "20px 20px 8px" : "20px",
        position: "relative",
        transition: "all 0.5s ease",
        flexGrow: 1,
      }),
    }),

  root: getCustomResponsiveStyles({
    tablet: css`
      display: flex;
    `,
    mobile: css`
      display: block;
      flex-direction: column;
      width: 100%;
    `,
  }),
};
